<!-- Start Page Title Area -->

<div class="page-title-area upper-margin">
    <div class="container">
        <div class="page-title-content">
            <br />
            <br />
            <h2>{{'Shop' | translate }}</h2>
            <!--<a routerLink="/">{{'Home' | translate }}/</a>-->
        </div>
    </div>
</div>

<div class="bg-color p-0">
    <div class="containers">
        <!------------------------------------------>
        <!------------------------------------------>
        <div class="row">
            <!-- data-aos="fade-up" data-aos-delay="100"-->
            <div class="title">
                <h4>{{ CategoryName }}</h4>
                <p>{{'We_found' | translate }} <strong>{{ dataSourceItems.data.length }}</strong> {{'products_available_for_you' | translate }}</p>
            </div>
            <!-- data-aos="fade-up" data-aos-delay="100"-->
            <div class="col-lg-4 col-md-6 ordering">
                <div>
                    <label>{{ 'Sort_By' | translate }}</label><br /><br />
                    <select class="form-select" (change)="onSortChange($event)">
                        <option value="Default">{{'Default' | translate }}</option>
                        <option value="Low to High">{{'Price_Low_to_High' | translate }}</option>
                        <option value="High to Low">{{'Price_High_to_Low' | translate }}</option>
                    </select>
                </div>
            </div>

        </div>

        <br />

        <div class="grid-container">
            <div class="row custom-grid">
                <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-3 g-lg-6 g-md-4 g-sm-2 g-1"
                     *ngFor="let item of (dataSourceItems.data | paginate: { itemsPerPage: 24, currentPage: currPages }); let i = index">

                    <div class="card d-flex flex-column">



                        <div class="card-main">
                            <!--<div class="discount">9%</div>-->
                            <div class="label2 label-red mt-5" *ngIf="item.activateWebDiscount == true && item.webDiscountFromDate < currentDate && item.webDiscountToDate > currentDate">{{'Sales' | translate }}</div>
                            <div class="label label-green" *ngIf="item.newArrival == true && item.newArrivalFromDate < currentDate && item.newArrivalToDate > currentDate">{{'New' | translate }}</div>


                            <div class="image d-flex" (click)="onClickItem(item.inItemID)">
                                <img class="card-image" [src]="apiURL + item.photoPath" alt="Product" />
                            </div>

                            <div class="cart-line">
                                <!--<div class="cart-item ">
                                <a (click)="addToCart(item)" href="javascript:void(0);" class="icon-design" *ngIf="item.isOutOfStock == false"><i class="fa-solid fa-basket-shopping icon-design"></i>{{'Add_to_Cart' | translate }}</a>

                            </div>-->
                            </div>
                        </div>

                        <div class="content">
                            <!-- *ngIf="item.isOutOfStock == false"-->
                            <div class="mt-0 pt-0">
                                <ng-template *ngIf="item.activateWebDiscount == true && item.webDiscountFromDate < currentDate && item.webDiscountToDate > currentDate ; then other_DiscountPrice; else  other_SalePrice">
                                </ng-template>
                                <ng-template #other_SalePrice>
                                    <div style="display: flex; flex-direction: column; justify-content: start; align-items: start; margin-top: 0;">
                                        <span class="old-price-none"> {{'-'}}</span>
                                        <span class="money">{{ ((item.saleTaxPercentage /100) * item.salesPrice) + item.salesPrice | number:'1.3-3' }} {{'OMR' | translate }} </span>
                                    </div>


                                </ng-template>
                                <ng-template #other_DiscountPrice>
                                    <div style="display: flex; flex-direction: column; justify-content: start; align-items: start;">
                                        <span class="old-price"> {{ ((item.saleTaxPercentage /100) * item.salesPrice) + item.salesPrice | number:'1.3-3' }} {{'OMR' | translate }}</span>
                                        <span class="money">{{ ((item.saleTaxPercentage /100) * item.webDiscountAmount) + item.webDiscountAmount | number:'1.3-3' }} {{'OMR' | translate }} </span>
                                    </div>



                                </ng-template>

                            </div>
                            <div class="mt-1">
                                <a class="item-name" href="javascript:void(0);" (click)="onClickItem(item.inItemID)">
                                    <ng-template *ngIf="SelectedLanguage == 'ar' ; then other_ItemAr  ; else other_ItemEn">
                                    </ng-template>
                                    <ng-template #other_ItemAr>{{ item.webNameAr }}</ng-template>
                                    <ng-template #other_ItemEn>{{ item.webNameEn }}</ng-template>
                                </a>
                            </div>

                            <div class="col-lg-12 col-md-12 mt-1">
                                <button type="button" (click)="addToCart(item)" class="cart-btn">{{'Add_To_Cart' | translate }} <i class='bx  bx-shopping-bag'></i></button>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 my-3">
            <div class=" text-center">
                <pagination-controls (pageChange)="onPageClick($event)"></pagination-controls>
            </div>
        </div>

        <!------------------------------------------>
        <!------------------------------------------>
    </div>
</div>
